const DANGEROUS_SYMBOLS_PATTERN = /[<>"'(){};`]/

export function addUrlParams(url, params) {
  if (!Object.keys(params).length) return url

  const {protocol, host, pathname} = new URL(url)

  const initialSearchParams = getSearchParams(url)
  const mergedSearchParams = {...initialSearchParams, ...params}

  const mergedSearchParamsString = new URLSearchParams(
    mergedSearchParams
  ).toString()

  return `${protocol}//${host}${pathname}?${mergedSearchParamsString}`
}

export function getSearchParams(url) {
  const {search} = new URL(url)
  const iterableSearchParams = new URLSearchParams(search)

  let searchParams = Array.from(iterableSearchParams.keys()).reduce(
    (sum, value) => {
      const currentValue = iterableSearchParams.get(value)

      if (DANGEROUS_SYMBOLS_PATTERN.test(currentValue)) return sum

      return Object.assign({[value]: currentValue}, sum)
    },
    {}
  )

  return searchParams
}

export function getFormattedUrl(url) {
  return !/^https?:\/\//i.test(url)
    ? `https://${url.replace(/^\/\//, '')}`
    : url
}
